import {debounce} from 'lodash';

export const resize = {
  data() {
    return {
      screenWidth: document.body.clientWidth || document.documentElement.clientWidth,

      hasEvent: false
    }
  },

  methods: {
    handleWidthChange() {
      this.screenWidth = document.body.clientWidth || document.documentElement.clientWidth;
    },

    calcToPx(ratio, min, max) {
      let rem = 0.05 * this.screenWidth;
      rem = Math.min(Math.max(rem, min), max);
      return ratio * rem + 'px';
    }
  },

  mounted() {
    window.addEventListener('resize', debounce(this.handleWidthChange, 400));
    this.hasEvent = true
  },

  activated() {
    if (!this.hasEvent) {
      window.addEventListener('resize', debounce(this.handleWidthChange, 400));
      this.hasEvent = true;
    }
  },

  deactivated() {
    if (this.hasEvent) {
      window.removeEventListener('resize', this.handleWidthChange);
      this.hasEvent = false;
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleWidthChange);
  }
}



// WEBPACK FOOTER //
// ./src/utils/resize.js